module.exports = __webpack_public_path__ + "static/algorand_full_logo_white-68a9427bc2c572e8ba99c3786542cf2c.png";